import { Box, Typography } from "@material-ui/core";
import React from "react";
import { ActionButton, DesktopPopupModal, Icon, IconName } from "halifax";
import clsx from "clsx";
import "./styles.scss";

export interface IActivitiesSurveyPromptProps {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  isMobile?: boolean;
  yesButton: () => void;
  noButton: () => void;
}

export const ActivitiesSurveyPrompt = (props: IActivitiesSurveyPromptProps) => {
  const { isOpen, isMobile, yesButton, noButton } = props;

  // const { matchesMobile } = useDeviceTypes();

  const ModalContent = React.useCallback(() => {
    return (
      <Box className="activities-survey-prompt-container">
        <Icon name={IconName.InfoCircleFill} />
        <Box className="activities-survey-prompt-content">
          <Typography variant="h4" className="activities-survey-prompt-title">
            {"Quick feedback on activities"}
          </Typography>
          <Typography className="activities-survey-prompt-subtitle">
            {"Got a minute to help us improve"}
          </Typography>
          <Box className="activities-survey-prompt-buttons">
            <ActionButton
              defaultStyle={"h4r-secondary"}
              onClick={yesButton}
              className={clsx("activities-survey-prompt-yes-button")}
              message={"Take the survey"}
            />
            <ActionButton
              onClick={noButton}
              className={clsx("activities-survey-prompt-no-button")}
              message={"Not right now"}
            />
          </Box>
        </Box>
      </Box>
    );
  }, []);

  return (
    <DesktopPopupModal
      open={isOpen}
      className={clsx("activities-survey-prompt-dialog", { mobile: isMobile })}
      onClose={noButton}
      invisibleBackdrop={false}
    >
      <ModalContent />
    </DesktopPopupModal>
  );
};
